import * as T from 'three';
// One reusable draw surface, no post-process, no frame-wise geometry or material allocation.
export function createSelectionFeedback(scene,ring){
 const geometry=new T.BoxGeometry(1,1,1),material=new T.MeshBasicMaterial({color:0xefbb68,transparent:true,opacity:.12,depthWrite:false});
 const fill=new T.Mesh(geometry,material);fill.name='reachable-selection-fill';fill.visible=false;fill.renderOrder=2;scene.add(fill);
 const bounds=ring.box,centre=new T.Vector3(),size=new T.Vector3();
 function show(){bounds.getCenter(centre);bounds.getSize(size);fill.position.copy(centre);fill.scale.copy(size);fill.visible=true;ring.visible=true;}
 return {fill,
  showTarget(object){object.updateWorldMatrix(true,true);bounds.setFromObject(object,true).expandByScalar(.009);show();},
  showPlacement(p,q){bounds.min.set(p.x-q.width/2,p.y+.003,p.z-q.depth/2);bounds.max.set(p.x+q.width/2,p.y+q.height+.003,p.z+q.depth/2);show();},
  hide(){ring.visible=false;fill.visible=false;},
  dispose(){fill.removeFromParent();geometry.dispose();material.dispose();}
 };
}
